import {
  ScreeningCondition,
  ScreeningConditionOperandType,
  ScreeningConditionSet,
} from '@common/entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetStoreAction } from 'state/commonActions';

import { buildSubsetHeadings } from 'utils/screeningConditionsDisplay';

export type ApplicationScreeningRequiredItems = {
  operandType: ScreeningConditionOperandType;
  requiredItemsInSubsetOne: number;
  requiredItemsInSubsetTwo: number;
};

export type ApplicationScreeningReducer = {
  conditionSets: ScreeningConditionSet[];
  subsetHeadings: any;
  requiredItems: ApplicationScreeningRequiredItems | null;
  selectedFinancialConditions: ScreeningCondition[];
  applicantName: string;
  applicationName: string;
  confirmationMessage: string;
};

const initialState: ApplicationScreeningReducer = {
  conditionSets: [],
  subsetHeadings: {},
  requiredItems: null,
  selectedFinancialConditions: [],
  applicantName: '',
  applicationName: '',
  confirmationMessage: '',
};

const getRequiredItems = (
  conditionSets: ScreeningConditionSet[],
): ApplicationScreeningRequiredItems | null => {
  if (conditionSets.length === 0) return null;

  const requiredItems: ApplicationScreeningRequiredItems = {
    operandType: conditionSets[0].operandType,
    requiredItemsInSubsetOne:
      conditionSets[0].subsets.length > 0
        ? (conditionSets[0].subsets[0].minSelect ?? conditionSets[0].subsets[0].requiredItems)
        : 0,
    requiredItemsInSubsetTwo:
      conditionSets[0].subsets.length > 1
        ? (conditionSets[0].subsets[1].minSelect ?? conditionSets[0].subsets[1].requiredItems)
        : 0,
  };
  return requiredItems;
};

export const applicationScreeningSlice = createSlice({
  name: 'applicationScreening',
  initialState,
  reducers: {
    setApplicationScreening: (state, action: PayloadAction<ApplicationScreeningReducer>) => {
      return {
        ...state,
        conditionSets: action.payload.conditionSets,
        subsetHeadings: buildSubsetHeadings(action.payload.conditionSets),
        requiredItems: getRequiredItems(action.payload.conditionSets),
        selectedFinancialConditions: action.payload.selectedFinancialConditions,
        applicantName: action.payload.applicantName,
        applicationName: action.payload.applicationName,
        confirmationMessage: action.payload.confirmationMessage,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStoreAction, () => initialState);
  },
});

export const { setApplicationScreening } = applicationScreeningSlice.actions;
export default applicationScreeningSlice.reducer;
